/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomCategoryRequest
 */
export interface CustomCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomCategoryRequest
     */
    customCategory: string;
}

/**
 * Check if a given object implements the CustomCategoryRequest interface.
 */
export function instanceOfCustomCategoryRequest(value: object): value is CustomCategoryRequest {
    if (!('customCategory' in value) || value['customCategory'] === undefined) return false;
    return true;
}

export function CustomCategoryRequestFromJSON(json: any): CustomCategoryRequest {
    return CustomCategoryRequestFromJSONTyped(json, false);
}

export function CustomCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomCategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customCategory': json['customCategory'],
    };
}

export function CustomCategoryRequestToJSON(value?: CustomCategoryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customCategory': value['customCategory'],
    };
}

